import { Tooltip } from "antd";
import { TFeatureWorkflowInstance } from "entity-app/models";
import { riskCellRenderer } from "components/cell-renders";
import {
  EWorkflowStatusDataBlock,
  ProjectPermissionEnum
} from "constants/index";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import EntityRiskThresholdSetting from "./entity-risk-threshold-setting";

function EntityRiskStatementView(props: {
  featureWorkflowInstance: TFeatureWorkflowInstance;
  actions: { updateFeatureWorkflowInstance: Function };
}) {
  const { tokenContents } = useContext(ProjectContext);
  const cannotEditRiskThreshold = isPermissionNotGrantted(
    ProjectPermissionEnum.EditRiskThreshold,
    tokenContents?.role!
  );

  const { featureWorkflowInstance: wfInstance, actions } = props;
  if (!wfInstance) return null;

  const isCompletedWorkflow =
    wfInstance.workflow_status === EWorkflowStatusDataBlock.WF_COMPLETED;
  if (isCompletedWorkflow)
    return (
      <div className="flex text-sm text-ciq-gray-800">
        {wfInstance.risk_assessment}
      </div>
    );

  return (
    <div className="flex space-x-2 items-center text-ciq-gray-800 text-opacity-80 text-sm font-medium">
      <div>Risk:</div>
      <Tooltip
        title={wfInstance.risk_assessment}
        className="cursor-default"
        placement="topRight"
      >
        {riskCellRenderer(
          { value: wfInstance.risk_level, data: wfInstance },
          true
        )}
      </Tooltip>
      {!cannotEditRiskThreshold && (
        <EntityRiskThresholdSetting
          featureTypeId={wfInstance.feature_type_id}
          threshold={wfInstance}
          actions={actions}
        />
      )}
    </div>
  );
}

export default EntityRiskStatementView;
